import { TOAST } from '../actionTypes';

const initialState = {
toasts:[],
children:null,
childrenData:[]
};

const toastReducer = (state = initialState, actions) => {
    switch (actions.type) {
        case TOAST.HANDLE_TOAST: {
            const renderSingle = actions?.payload?.renderSingle//if you want to render single toast
            if (renderSingle) {
                //checking if render single exists already in array then replace if doesn't then push
                const index = state.toasts.findIndex(toast => toast.renderSingle)
                if (index === -1) {
                    return {
                        ...state,
                        toasts: [...state.toasts, actions.payload]
                    };
                }
                else {
                    const updatedToasts = [...state.toasts];
                    updatedToasts[index] = actions.payload;
                    return {
                        ...state,
                        toasts: updatedToasts,
                    };
                }

            }
            else {
                return {
                    ...state,
                    toasts: [...state.toasts, actions.payload]
                };
            }
        }
         case TOAST.REMOVE_TOAST: {
            return {
                ...state,
                toasts:state.toasts.filter(toast => toast.id !== actions.payload), // Remove the specific toast by id
            };
        }
        case TOAST.HANDLE_CHILDREN: {
            return {
                ...state,
                 children: actions.payload
            };
        }
        case TOAST.HANDLE_CHILDREN_DATA: {
            return {
                ...state,
                childrenData: actions.payload
            };
        }
        default:
            return state;
    }

};

export default toastReducer;